"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;
exports.styles = void 0;

var styles_1 = require("@mui/styles"); //Primero creo un estilo por defecto y luego según la necesidad cambio el objeto


var defaultStyles = {
  "& .ReactInputVerificationCode__item": {
    position: "relative",
    color: "#262626",
    fontWeight: 600,
    border: "1px solid grey",
    boxShadow: 'none'
  },
  "& .ReactInputVerificationCode__item:hover": {
    border: "1px solid black"
  },
  "& .ReactInputVerificationCode__item.is-active": {
    border: "1px solid #00acc1",
    boxShadow: 'none'
  },
  "& .ReactInputVerificationCode__item:after": {
    content: "",
    display: "block",
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
    transition: "background-color 1s ease-out"
  }
};
exports.styles = (0, styles_1.makeStyles)({
  customStyles: defaultStyles,
  // Creo estilo para cuando onError = true
  customStylesOnError: __assign(__assign({}, defaultStyles), {
    "& .ReactInputVerificationCode__item": {
      border: "1px solid red",
      boxShadow: "none",
      fontWeight: 400
    }
  }),
  //Creo estilo para cuando disabled = true
  customStylesDisabled: __assign(__assign({}, defaultStyles), {
    "& .ReactInputVerificationCode__item": {
      color: "#E5E5E5",
      pointerEvents: "none"
    }
  })
});